var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowcircleright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66675C8.65317 2.66675 2.6665 8.65341 2.6665 16.0001C2.6665 23.3467 8.65317 29.3334 15.9998 29.3334C23.3465 29.3334 29.3332 23.3467 29.3332 16.0001C29.3332 8.65341 23.3465 2.66675 15.9998 2.66675ZM19.7198 16.7067L15.0132 21.4134C14.8132 21.6134 14.5598 21.7067 14.3065 21.7067C14.0532 21.7067 13.7998 21.6134 13.5998 21.4134C13.4139 21.2252 13.3096 20.9713 13.3096 20.7067C13.3096 20.4422 13.4139 20.1883 13.5998 20.0001L17.5998 16.0001L13.5998 12.0001C13.4139 11.8119 13.3096 11.558 13.3096 11.2934C13.3096 11.0288 13.4139 10.7749 13.5998 10.5867C13.9865 10.2001 14.6265 10.2001 15.0132 10.5867L19.7198 15.2934C20.1198 15.6801 20.1198 16.3201 19.7198 16.7067Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcircleright);
export default __webpack_public_path__ + "static/media/arrowcircleright.6b818aee6a7e06a8228cce847627fc70.svg";
export { ForwardRef as ReactComponent };